import { useEffect } from 'react';
import loadAceDiff from './loadAceDiff';
import styleUnchangedFolds from './styleUnchangedFolds';

export default function useAceDiff({ leftEditor, rightEditor, oldValue, newValue, collapseUnchanged, foldable }) {
  useEffect(() => {
    if (!leftEditor || !rightEditor) {
      return;
    }

    let canceled = false;
    let diffView;
    let stopStylingUnchangedFolds;

    loadAceDiff().then(({ createDiffView }) => {
      if (canceled) {
        return;
      }

      diffView = createDiffView(
        {
          editorA: leftEditor,
          editorB: rightEditor,
        },
        {
          folding: foldable,
          wrap: true,
        }
      );
      if (foldable) {
        leftEditor.setOption('fadeFoldWidgets', false);
        rightEditor.setOption('fadeFoldWidgets', false);
      }
      diffView.onInput();
      if (collapseUnchanged) {
        diffView.foldUnchanged();
        stopStylingUnchangedFolds = styleUnchangedFolds([leftEditor, rightEditor]);
      }
    });

    return () => {
      canceled = true;
      if (!diffView) {
        return;
      }

      if (collapseUnchanged) {
        stopStylingUnchangedFolds?.();
        diffView.unfoldUnchanged();
      }
      // ReactAce retains ownership of the editors across diff recalculations and unmounts.
      diffView.detach();
    };
  }, [leftEditor, rightEditor, oldValue, newValue, collapseUnchanged, foldable]);
}
